import React, { useEffect } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
// import { ColorModeSwitcher } from "./ColorModeSwitcher"
import Routes from './Router';
import theme from './styles/theme';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';

import {
  initialize,
  validateAuthToken,
  validateEntrataAuthCode,
} from './actions/auth';
import Notification from './components/UI/Notification';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function App(props: AppProps) {
  let { initialize, validateAuthToken, validateEntrataAuthCode } = props;
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const isReferedByEntrata = urlParams.get('referrer') === 'entrata';
    const authCode = urlParams.get('auth_code');

    const tokenChecker = setInterval(() => {
      validateAuthToken();
    }, 5 * 60 * 1000);

    if (isReferedByEntrata && authCode) {
      validateEntrataAuthCode(authCode);
    } else if (initialize) initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps

    return () => {
      clearInterval(tokenChecker);
    };
  }, [initialize, validateAuthToken, validateEntrataAuthCode, location.search]);

  let cspString = `default-src 'self'; script-src 'self' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; style-src 'unsafe-inline' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; img-src 'self' data: https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; connect-src https://*.beekin.co https://*.sentry.io https://*.amazonaws.com https://api-js.mixpanel.com; font-src 'self' https://fonts.gstatic.com`;

  if (process.env.NODE_ENV === 'development') {
    cspString = `default-src 'self'; script-src 'self' 'unsafe-inline' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; style-src 'unsafe-inline' https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; img-src 'self' data: https://fonts.googleapis.com https://d2twymdrqimvrw.cloudfront.net; connect-src http://localhost:* https://*.beekin.co https://*.sentry.io https://*.amazonaws.com https://api-js.mixpanel.com; font-src 'self' https://fonts.gstatic.com`;
  }

  return (
    <ChakraProvider theme={theme}>
      <HelmetProvider>
        <Routes />
        <Notification />
        <Helmet>
          <meta charSet="utf-8" />
          <meta http-equiv="Content-Security-Policy" content={cspString}></meta>
          <meta http-equiv="X-Content-Type-Options" content="nosniff"></meta>
          <meta http-equiv="Referrer-Policy" content="no-referrer"></meta>
          <meta
            http-equiv="Feature-Policy"
            content="microphone none; geolocation none; camera none;"
          ></meta>
        </Helmet>
      </HelmetProvider>
    </ChakraProvider>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      initialize,
      validateAuthToken,
      validateEntrataAuthCode,
    },
    dispatch
  );

const connector = connect(undefined, mapDispatchToProps);

type AppProps = ConnectedProps<typeof connector>;

export default connector(App);
